var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as actions from '@returnmates/client-core/src/constants/actionTypes';
import { getAddressValidationFeedback } from '@returnmates/client-core/src/selectors/admin';
import { SnackBarStatuses } from '@returnmates/client-core/src/type';
import errorMapper from '@returnmates/client-core/src/utils/errorMapper';
import { createAsyncAction } from '@returnmates/client-core/src/utils/reduxUtils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useField } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
export var useGoogleValidation = function (_a) {
    var formName = _a.formName, _b = _a.withGoogleValidation, withGoogleValidation = _b === void 0 ? false : _b, _c = _a.shouldValidateOnInit, shouldValidateOnInit = _c === void 0 ? true : _c;
    var dispatch = useDispatch();
    var _d = useState(false), isValidatingAddressLoading = _d[0], setIsValidatingAddressLoading = _d[1];
    var _e = useState(withGoogleValidation), isGoogleValidationEnabled = _e[0], setIsGoogleValidationEnabled = _e[1];
    var _f = useState(), autocomplete = _f[0], setAutocomplete = _f[1];
    var nameInput = useField(formName ? "".concat(formName, ".name") : 'name').input;
    var phoneInput = useField(formName ? "".concat(formName, ".phone") : 'phone').input;
    var unitInput = useField(formName ? "".concat(formName, ".unit") : 'unit').input;
    var streetInput = useField(formName ? "".concat(formName, ".street") : 'street').input;
    var zipCodeInput = useField(formName ? "".concat(formName, ".zipCode") : 'zipCode').input;
    var stateInput = useField(formName ? "".concat(formName, ".state") : 'state').input;
    var cityInput = useField(formName ? "".concat(formName, ".city") : 'city').input;
    var addressValidationFeedback = useSelector(getAddressValidationFeedback);
    var onLoad = useCallback(function (autocompleteInstance) {
        setAutocomplete(autocompleteInstance);
    }, []);
    var getHelperTextForRequiredField = function (_a) {
        var name = _a.name, value = _a.value;
        if (!(value === null || value === void 0 ? void 0 : value.length)) {
            return "".concat(name[0].toUpperCase() + name.slice(1), " is required!");
        }
        return null;
    };
    var onPlaceChanged = useCallback(function () {
        if (!autocomplete)
            return;
        var place = autocomplete.getPlace();
        if (!(place === null || place === void 0 ? void 0 : place.address_components))
            return;
        var street = place.address_components.find(function (ad) { return ad.types.includes('route'); });
        if (street) {
            var streetNumber = place.address_components.find(function (ad) { return ad.types.includes('street_number'); });
            if (streetNumber) {
                streetInput.onChange("".concat(streetNumber.long_name, " ").concat(street.long_name));
            }
            else {
                streetInput.onChange(street.long_name);
            }
        }
        var zipCode = place.address_components.find(function (ad) { return ad.types.includes('postal_code'); });
        if (zipCode) {
            zipCodeInput.onChange(zipCode.long_name);
        }
        var city = place.address_components.find(function (ad) { return ad.types.includes('locality'); });
        if (city) {
            cityInput.onChange(city.long_name);
        }
    }, [autocomplete, cityInput, streetInput, zipCodeInput]);
    var validateAddress = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsValidatingAddressLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createAsyncAction(dispatch, actions.getAddressValidationFeedback.request({
                            input: {
                                street: streetInput.value,
                                unit: unitInput.value,
                                city: cityInput.value,
                                state: stateInput.value,
                                zipCode: zipCodeInput.value,
                            },
                            requestId: addressValidationFeedback === null || addressValidationFeedback === void 0 ? void 0 : addressValidationFeedback.responseId,
                        }))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    message = err_1.message;
                    dispatch(actions.addSnackBar.request({
                        type: SnackBarStatuses.ERROR,
                        message: errorMapper(message || err_1),
                    }));
                    setIsValidatingAddressLoading(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsValidatingAddressLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        addressValidationFeedback === null || addressValidationFeedback === void 0 ? void 0 : addressValidationFeedback.responseId,
        cityInput.value,
        dispatch,
        stateInput.value,
        streetInput.value,
        unitInput.value,
        zipCodeInput.value,
    ]);
    var isValidateButtonEnabled = useMemo(function () {
        return Boolean((streetInput === null || streetInput === void 0 ? void 0 : streetInput.value) &&
            (cityInput === null || cityInput === void 0 ? void 0 : cityInput.value) &&
            (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.value) &&
            (phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value) &&
            (nameInput === null || nameInput === void 0 ? void 0 : nameInput.value));
    }, [
        cityInput === null || cityInput === void 0 ? void 0 : cityInput.value,
        nameInput === null || nameInput === void 0 ? void 0 : nameInput.value,
        phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value,
        streetInput === null || streetInput === void 0 ? void 0 : streetInput.value,
        zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.value,
    ]);
    var resetAddressValidation = useCallback(function () {
        createAsyncAction(dispatch, actions.resetAddressValidationFeedback.request({}));
    }, [dispatch]);
    useEffect(function () {
        if (!shouldValidateOnInit)
            return;
        if (isGoogleValidationEnabled) {
            validateAddress();
        }
        else {
            resetAddressValidation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, isGoogleValidationEnabled]);
    var toggleGoogleValidation = useCallback(function () {
        setIsGoogleValidationEnabled(function (prev) { return !prev; });
    }, []);
    return {
        isValidatingAddressLoading: isValidatingAddressLoading,
        isGoogleValidationEnabled: isGoogleValidationEnabled,
        toggleGoogleValidation: toggleGoogleValidation,
        onLoad: onLoad,
        onPlaceChanged: onPlaceChanged,
        validateAddress: validateAddress,
        isValidateButtonEnabled: isValidateButtonEnabled,
        getHelperTextForRequiredField: getHelperTextForRequiredField,
        resetAddressValidation: resetAddressValidation,
    };
};
//# sourceMappingURL=useGoogleValidation.js.map